module.exports = __webpack_public_path__ + "static/Sequence_Galavanize_Homepage-15a303aeef023cd5491d410a5e8d3cd1.mp4";